import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import {
  InputsConfirmationContract,
  InputsConfirmationPayment,
  InputsConfirmationProducer,
  InputsProductionContract,
  InputsProductionGerente,
  InputsProductionOperator,
} from "../ReportsProductionTypes";
import { InputsProductionSupervisor } from "../ReportsProductionTypes";
import { FormatDateDayLastMonth } from "src/shared/Utils/FormatDate/FormatDateDayLastMonth";

export const valuesDefaultInputsReportsSupervisor: InputsProductionSupervisor = {
  type_date: "ASSINATURA",
  start_date: `${FormatDateDayLastMonth().firstDayMonth}`,
  end_date: `${GetDateUSSemValue()}`,
  resume: "FALSE",
  type_report: "ALL",

  id_filial: [],
  operadoras: [],
  modalidades: [],
  administradoras: [],
};

export const valuesDefaultInputsReportsGerente: InputsProductionGerente = {
  type_date: "ASSINATURA",
  start_date: `${FormatDateDayLastMonth().firstDayMonth}`,
  end_date: `${GetDateUSSemValue()}`,
  type_report: "ALL",
};

export const valuesDefaultInputsReportsProduction: InputsProductionContract = {
  type_date: "ASSINATURA",
  start_date: `${FormatDateDayLastMonth().firstDayMonth}`,
  end_date: `${GetDateUSSemValue()}`,

  id_filial: [],
  operadoras: [],
  modalidades: [],
  administradoras: [],

  type_report: "ALL",
  is_group: "TRUE",
  font_lead: "NONE",
};

export const valuesDefaultInputsReportsOperator: InputsProductionOperator = {
  type_date: "ASSINATURA",
  start_date: `${GetDateUSSemValue()}`,
  end_date: `${GetDateUSSemValue()}`,

  id_filial: [],
  operadoras: [],
  modalidades: [],
  administradoras: [],

  type_report: "ALL",
};

export const InputsDefaultReportsConfirmationContract: InputsConfirmationContract =
{
  start_date_payment: `${GetDateUSSemValue()}`,
  end_date_payment: `${GetDateUSSemValue()}`,

  start_date_signature: "",
  end_date_signature: "",

  start_date_due: "",
  end_date_due: "",

  id_filial: [],
  operadoras: [],
  modalidades: [],
  administradoras: [],

  type_report: "ALL",
  type_report_parcelas: "ALL",

  installmentNumber: "",
  installmentNumberOperator: "ALL",
  is_vitalicio_corretora: "ALL",
  is_vitalicio_corretor: "ALL",
  is_vitalicio_supervisor: "ALL",
  is_vitalicio_gerente: "ALL",
};

export const InputsDefaultReportsConfirmationProducer: InputsConfirmationProducer =
{
  start_date_payment: `${GetDateUSSemValue()}`,
  end_date_payment: `${GetDateUSSemValue()}`,

  start_date_signature: "",
  end_date_signature: "",

  start_date_due: "",
  end_date_due: "",

  id_filial: [],
  operadoras: [],
  modalidades: [],
  administradoras: [],

  type_report: "ALL",

  installmentNumber: "",
  installmentNumberOperator: "ALL",
  is_vitalicio_corretora: "ALL",
  is_vitalicio_corretor: "ALL",
  is_vitalicio_supervisor: "ALL",
  is_vitalicio_gerente: "ALL",
};

export const InputsDefaultReportsConfirmationPayment: InputsConfirmationPayment = {
  start_date: `${FormatDateDayLastMonth().firstDayMonth}`,
  end_date: `${GetDateUSSemValue()}`,

  type_report: "ALL",
  funcao_produtor: "",
};
